/**
 * Centralized React Query key factory.
 *
 * Each entry returns a stable key tuple.  Using a factory avoids typo-based
 * mismatches and makes it easy to invalidate the right scope:
 *
 *   queryClient.invalidateQueries({ queryKey: queryKeys.assets.root })
 *
 * …will match every query whose key starts with ["assets"].
 */
export const queryKeys = {
  assets: {
    /** Matches every assets-list query variant (all filters, all users). */
    root: ["assets"] as const,
    /** A specific filtered list query. */
    list: (userId: string | undefined, filters: Record<string, unknown> | undefined) =>
      ["assets", userId, filters] as const,
  },
  asset: {
    /** Matches every single-asset detail query. */
    root: ["asset"] as const,
    /** A specific asset detail query. */
    detail: (id: string) => ["asset", id] as const,
  },
  pendingAssets: {
    root: ["pending-assets"] as const,
    list: (userId: string | undefined) => ["pending-assets", userId] as const,
  },
  tags: {
    root: ["user_tags"] as const,
  },
  assetRecalls: {
    detail: (assetId: string) => ["asset-recalls", assetId] as const,
  },
  pushSubscription: {
    root: ["push-subscription"] as const,
  },
  notificationPreferences: {
    root: ["notification-preferences"] as const,
    detail: (userId: string) => ["notification-preferences", userId] as const,
  },
} as const;
